import React from 'react';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Card from '../../common/Card';

export default ({ arrivedAt, startProductionAt,os, ordemServicoSequencia, completedAt, despachedAt, teveRetrabalho, updatedAt, processo, osId, situacao, etapa, questions, isCustomStyle }) => {
  let xC = (<React.Fragment/>);
  console.log("completedAt,despachedAt",  completedAt, despachedAt)
  if (completedAt != null) { xC = (
      <ListItem style={{display:'flex', justifyContent:'space-between'}}>
        <Typography  style={{ fontSize: '0.8rem'}}>CONCLUSÃO:</Typography>
        <Typography style={{ fontSize: '1.3rem'}}>{completedAt}</Typography>
      </ListItem>) }
  let xS = (<React.Fragment/>);
  if (despachedAt != null) { xS = (
      <ListItem style={{display:'flex', justifyContent:'space-between'}}>
        <Typography  style={{ fontSize: '0.8rem'}}>SAIDA:</Typography>
        <Typography style={{ fontSize: '1.3rem'}}>{despachedAt}</Typography>
      </ListItem>) }
  let xT = (<React.Fragment/>);
  if (teveRetrabalho !== null && teveRetrabalho) { xT = (
      <ListItem style={{display:'flex', justifyContent:'space-between'}}>
        <Typography  style={{ fontSize: '0.8rem', color: 'red'}}>RETRABALHO:</Typography>
        <Typography style={{ fontSize: '1.3rem'}}>SIM</Typography>
      </ListItem>) }

  return (
    <React.Fragment>
      <Card isCustomStyle>
        <Typography variant="subtitle1" style={{textAlign:"center", fontSize: '1.5rem'}}>ORDEM DE SERVIÇO</Typography>
        {/*<Typography variant="subtitle1" style={{textAlign:"center", fontSize: '1.5rem'}}>{os}</Typography>*/}

        <List>
          <ListItem  style={{display:'flex', justifyContent:'space-between'}}>
            <Typography style={{ fontSize: '0.8rem'}}># | COLETA ORG:</Typography>
            <Typography  style={{ fontSize: '1.3rem'}}>{os} | {ordemServicoSequencia}</Typography>
          </ListItem>
          <ListItem  style={{display:'flex', justifyContent:'space-between'}}>
            <Typography style={{ fontSize: '0.8rem'}}>PROCESSO:</Typography>
            <Typography  style={{ fontSize: '1.3rem'}}>{processo}</Typography>
          </ListItem>
          <ListItem  style={{display:'flex', justifyContent:'space-between'}}>
            <Typography style={{ fontSize: '0.8rem'}}>CHEGADA:</Typography>
            <Typography style={{ fontSize: '1.3rem'}}>{arrivedAt}</Typography>
          </ListItem>
          <ListItem style={{display:'flex', justifyContent:'space-between'}}>
            <Typography style={{ fontSize: '0.8rem'}}>INICIO:</Typography>
            <Typography  style={{ fontSize: '1.3rem'}}>{startProductionAt}</Typography>
          </ListItem>
          <ListItem style={{display:'flex', justifyContent:'space-between'}}>
            <Typography style={{ fontSize: '0.8rem'}}>SITUAÇÃO:</Typography>
            <Typography  style={{ fontSize: '1.3rem'}}>{situacao}</Typography>
          </ListItem>
          <ListItem style={{display:'flex', justifyContent:'space-between'}}>
            <Typography style={{ fontSize: '0.8rem'}}>ETAPA:</Typography>
            <Typography  style={{ fontSize: '1.3rem'}}>{etapa}</Typography>
          </ListItem>
          { xC }
          { xS }
          { xT }
          <ListItem style={{display:'flex', justifyContent:'space-between'}}>
            <Typography style={{ fontSize: '0.8rem'}}>id:</Typography>
            <Typography  style={{ fontSize: '0.6rem'}}>{osId}</Typography>
          </ListItem>
          {/*<ListItem>Atualizado em: {updatedAt}</ListItem>*/}
        </List>
      </Card>
    </React.Fragment>
  )
}
